// extracted by mini-css-extract-plugin
export default {"button":"button_button__nTh6B","active":"button_active__MffSJ"};